class GeoCoord {
  constructor(lat = undefined, long = undefined) {
    this.latitude = Number(lat)
    this.longitude = Number(long)
  }
  get isDefined() {
    return !!this.latitude && !!this.longitude
  }
  get lat() {
    return this.latitude
  }
  get long() {
    return this.longitude
  }
  isEqual(geoCoord) {
    return (
      this.latitude == geoCoord.latitude && this.longitude == geoCoord.longitude
    )
  }
  clone() {
    return new this.constructor(this.latitude, this.longitude)
  }
}

class GeoCoords {
  constructor() {
    this._list = []
  }

  get list() {
    return this._list
  }
  set list(l) {
    this._list = l
  }

  // TODO perhasp just add... consider base class for lists.
  addGeoCoord(geoCoord) {
    // TODO consider if argument check and potential rejections is meaningful.
    this._list.push(geoCoord)
    return this
  }
  clone() {
    return new this.constructor(this._list.map((g) => g.clone()))
  }
}

export { GeoCoord, GeoCoords }
